import codes from '@/codes';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as forge from 'node-forge'
import * as _ from 'lodash';
import reg from '@/reg';

// i18n vue
import logLoginList from '../../../Log/login/login.Admin.List.i18n'
import logActionList from '../../../Log/action/action.Admin.List.i18n'

//restful api
import { admin as manager } from '@/service/api/manager';

const default_model = () => (
  { is_alive : true, permissions : 'Owner' }
);

export default {
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  components: {
    cSwitch,
    vSelect,
    logLoginList,
    logActionList
  },
  data : () => ({
      codes,
      confirm: false,
      add: false,
      lock: true,
      group_list: undefined,
      model : default_model(),
      allowed: false,
      region : {
        language : codes.language_default,
        country : codes.country_default,
        timezone : codes.timezone_default
      },
      password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
  }),
  methods: {
    //reset mail
    async send_password_reset_mail() {
      let rs = await manager.resetAdmin({ id : this.model.id });
      return rs.is_error ? this.$toastr.e("sending Password Reset Mail", "failed") : this.$toastr.s("Password Reset Mail", "Sented");
    },
    password_policy(type = '')
    {
      switch (type) {
        case 'number':
          this.password_meter.is_number = this.model.new_password && reg.reg_number.test(this.model.new_password) ? true : false;
          return this.password_meter.is_number;
        case 'uppercase':
          this.password_meter.is_alphabat_upper = this.model.new_password && reg.reg_alphabat_upper.test(this.model.new_password) ? true : false;
          return this.password_meter.is_alphabat_upper;
        case 'lowercase':
          this.password_meter.is_alphabat_lower = this.model.new_password && reg.reg_alphabat_lower.test(this.model.new_password) ? true : false;
          return this.password_meter.is_alphabat_lower;
        case 'spacial':
          this.password_meter.is_spacial = this.model.new_password && reg.reg_spacial.test(this.model.new_password) ? true : false;
          return this.password_meter.is_spacial;
        case 'length':
          this.password_meter.check_length = (this.model.new_password && this.model.new_password.length >= 10) ? true : false
          return this.password_meter.check_length;
        // eslint-disable-next-line no-case-declarations
        case 'all':
          let keys = Object.keys(this.password_meter);
          for (let i = 0; i < keys.length; i++) {
            // if has can't pass
            if(!this.password_meter[keys[i]]) { return { is_error : true, key : keys[i] }; }
          }
          // all pass
          return { is_error : false };
        default:
          return false;
      }
    },
    cancel: function() {
      if(this.$route.params.id == "add") { this.list(); }
      this.lock = true
    },
    edit:function() {
      this.lock = false
    },
    set_country:function(x) { if(!x) { return; } this.model.country = x.value },
    set_timezone:function(x) { if(!x) { return; } this.model.timezone = x.value },
    set_language:function(x) { if(!x) { return; } this.model.language = x.value },
    async remove() {
      try {
        let rs  = await manager.deleteAdmin({id : this.model.id});
        if(!rs.error) {
          this.$toastr.s('Removed'); this.list();
        } else {
          this.$toastr.e('delete', "failed"); this.cancel();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
    },
    list() { this.$router.push({ name: 'admin'}); this.$emit('refresh'); },
    async save() {
      let model = {}

      // check validation
      try {
        if(!(this.model.username || '').trim()) { return this.$toastr.e('Username(ID) Required.'); }
        // if(!this.model.id && !this.model.new_password) { return this.$toastr.e('Password Required.'); }
        if(this.model.new_password && this.model.new_password != this.model.new_password_repeat) { return this.$toastr.e('Password repeat do not match'); }
        if(this.model.new_password) {
          var rs = this.password_policy('all')
          if(rs.is_error) {
            var msg = rs.key.indexOf('is') > -1 ? rs.key.substring(3) : rs.key;
            return this.$toastr.e(`Please check password policy [${msg}]`);
          }
        }
      } catch (e) { console.log(e); return this.$toastr.e('check validation failed'); }

      // build data for sending
      model = Object.assign({}, this.model, { permissions : codes.permissions_admin_value[this.model.permissions] })
      if(model.new_password) { model.new_password = forge.sha256.create().update(model.new_password).digest().toHex(); }
      if(model.group && model.group.id) { model.group_id = model.group.id; }
      if(this.model.allow_ip_list) {
        model.allow_ip = _.uniq(_.compact(this.model.allow_ip_list.replace(/,/gm, '').split("\n")));
        // b-form-textarea has bug, can not bind model so rirect update
        this.model.allow_ip_list = _.join(model.allow_ip, '\n')
        this.$refs.allow_ip_list.localValue = _.join(model.allow_ip, '\n')
      } else { model.allow_ip = "" }

      // set region
      if(!this.region.country) { return this.$toastr.e('Country Required.'); }
      if(!this.region.timezone) { return this.$toastr.e('Timezone Required.'); }
      if(!this.region.language) { return this.$toastr.e('Language Required.'); }

      let region = {};
      region.country = this.region.country.value
      region.language = this.region.language.value
      region.timezone = this.region.timezone.value

      try {
        let check_id = '';
        check_id = this.model.id ? `${await manager.updateAdmin(Object.assign({}, this.model, model, region))}` : `${await manager.insertAdmin(Object.assign({}, this.model, model, region))}`

        let rs =  check_id;
        if(!rs.error) {
          this.model.new_password = ""
          this.model.new_password_repeat = ""
          this.$toastr.s('Saved', this.$route.name);
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
        this.refresh(rs.body.id);
      } catch(e) { this.$toastr.e(e ? e.data ? e.data : e : e.statusText), this.list() }

      this.lock = true;
    },
    refresh(id) {
      this.$router.push({ name: 'admin', params : { id : id ? id : this.$route.params.id } });
    },
    async get({ id, tag } = this.$route.params) {
      this.model = default_model()

      console.log('admin.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model.is_alive = true; return; }
      try{
        this.model.id = Number(id);
        this.add = false;
        this.lock = (tag != 'edit');

        let rs = await manager.detailAdmin({ id : id })
        this.model = Object.assign({ group: {} }, this.model, rs.body)

        let is_done_country = false;
        codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

        let is_done_language = false;
        codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

        let is_done_timezone = false;
        codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });

        this.model.allow_ip_list = this.model.allow_ip && this.model.allow_ip.join("\n")

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list() }
    }
  },
  created() { console.log('admin_Detail.vue', 'created'); },
  destroyed() { console.log('admin_Detail.vue', 'destroyed'); },
  mounted() {
    console.log('admin_Detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}